import type { ReactNode } from 'react'

/**
 * Het rode sterretje achter het label van een verplicht veld (besluit van 1 november 2026, ontwerp
 * 10.3, R-09).
 *
 * `aria-hidden`, want een schermlezer zou "ster" voorlezen: hij hoort "verplicht" via `aria-required`
 * op de control zelf (R-139). De kleur is de foutkleur uit het tokenbestand (`schil.css`), die op wit
 * 6,19:1 haalt. Eén component, zodat de schil en het akkoord (`Toggle.tsx`) hetzelfde teken tekenen.
 */
export function RequiredMark(): ReactNode {
  return (
    <span className="ef-veld__verplicht" aria-hidden="true">
      *
    </span>
  )
}
